<script lang="ts">
  import NoAccountCta from '../Navigation/NoAccountCTA.svelte'
  import SignedOutUserTopBarPage from '../Navigation/TopLevelPages/SignedOutUserTopBarPage.svelte'
</script>

<SignedOutUserTopBarPage>
  <p>You first need to create an account on the app.</p>
  <NoAccountCta />
</SignedOutUserTopBarPage>
